import { useEffect, useState } from 'react';

/** The phone layout (index.css's `phone` breakpoint, max-width 720px), for markup that differs
 *  rather than restyles (a table becomes cards). False where matchMedia is missing (tests). */
const QUERY = '(max-width: 720px)';
const media = () => (typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia(QUERY) : null);

export function usePhone(): boolean {
  const [phone, setPhone] = useState(() => media()?.matches ?? false);
  useEffect(() => {
    const m = media();
    if (!m) return;
    const on = () => setPhone(m.matches);
    m.addEventListener('change', on);
    return () => m.removeEventListener('change', on);
  }, []);
  return phone;
}
